import mitt from 'mitt';

const emitter=new mitt();

export default emitter;